// Location data structure with enemy probabilities and types
const locations = {
  "chiba-city": {
    name: "Chiba City",
    type: "city",
    description:
      "Known worldwide for its implants, nerve-splicing, and microbionics, the city is a mix of corporate arcologies, surgery boutiques and black market labs.",
    quotes: [
      "The sky above the port was the color of television, tuned to a dead channel.",
      "Behind the port lay the city, factory domes dominated by the vast cubes of corporate arcologies.",
      "Port and city were divided by a narrow borderland of older streets, an area with no official name.",
      "The air had gotten worse; it seemed to have teeth tonight, and half the crowd wore filtration masks.",
      "Biz here was a constant subliminal hum, and death the accepted punishment for laziness, carelessness, lack of grace, the failure to heed the demands of an intricate protocol.",
    ],
    locations: ["night-city"],
  },

  "night-city": {
    name: "Night City",
    type: "region",
    description:
      "A narrow borderland between port and city, dormant by day. By night a playground of light and noise where law and order give way to experimentation, commerce, and vice.",
    quotes: [
      "Night City was like a deranged experiment in social Darwinism, designed by a bored researcher who kept one thumb permanently on the fast-forward button.",
      "Stop hustling and you sank without a trace, but move a little too swiftly and you'd break the surface tension of the black market; either way, you were gone.",
      "By day, the bars down Ninsei were shuttered and featureless, the neon dead, the holograms inert, waiting, under the poisoned silver sky.",
      "…the electric dance of Ninsei…",
      "...a hundred faces from the neon forest, sailors and hustlers and whores, where the sky is poisoned silver, beyond chainlink and the prison of the skull.",
      "Down on Ninsei the holograms were vanishing like ghosts, and most of the neon was already cold and dead.",
      "Beyond the neon shudder of Ninsei, the sky was that mean shade of gray.",
      "The air had gotten worse; it seemed to have teeth tonight, and half the crowd wore filtration masks.",
      "Biz here was a constant subliminal hum, and death the accepted punishment for laziness, carelessness, lack of grace, the failure to heed the demands of an intricate protocol.",
      "Groups of sailors up from the port, tense solitary tourists hunting pleasures no guidebook listed, Sprawl heavies showing off grafts and implants…",
      "…a dozen distinct species of hustler, all swarming the street in an intricate dance of desire and commerce.",
      "Burgeoning technologies require outlaw zones… Night City wasn't there for its inhabitants, but as a deliberately unsupervised playground for technology itself.",
    ],
    locations: [
      "chatsubo",
      "shins",
      "ninsei-strip",
      "arcade",
      //"chiba-docks",
      //"jarre-de-the",
      "cheap-hotel",
      //"julius-dean-import-export",
      //"beautiful-girl",
      //"namban",
    ],
  },

  "corporate-arcology": {
    name: "Corporate Arcology",
    type: "region",
    description:
      "The Corporate District rises above the sprawl like a fortress of glass and steel. Here, the air is filtered, the streets are clean, and security is omnipresent. Drones patrol the skies, biometric scanners guard every entrance. This is where the real money flows.",
    quotes: [
      "The Corporate District rises above the sprawl like a fortress of glass and steel.",
      "Here, the air is filtered, the streets are clean, and security is omnipresent.",
      "Drones patrol the skies, biometric scanners guard every entrance.",
      "This is where the real money flows.",
    ],
    locations: [
      "corporate-black-clinic",
      "mega-corp-towers",
      "hosaka-facility",
      "corporate-streets",
      "corporate-market",
    ],
  },

  chatsubo: {
    name: "The Chatsubo",
    type: "bar",
    description:
      "Ratz tends the bar, his arm jerking monotonously as he fills a tray of glasses with draft Kirin.",
    quotes: [
      "The Chatsubo was a bar for professional expatriates; you could drink there for a week and never hear two words in Japanese.",
      "The regulars were still there, most of them, but they faded behind an influx of sailors and the specialists who preyed on them.",
      "The bartender's smile widened. His ugliness was the stuff of legend. In an age of affordable beauty, there was something heraldic about his lack of it.",
      "Rat'z arm whined as he reached for another mug. It was a military prosthesis, a seven-function force-feedback manipulator, cased in grubby pink plastic.",
      "Lonny Zone, the bar's resident pimp, was observing with glazed fatherly interest as one of his girls went to work on a young sailor.",
    ],
    parent: "night-city",
    people: [
      { id: "ratz", name: "Ratz" },
      { id: "lonny_zone", name: "Lonny Zone" },
      { id: "sailor", name: "Sailor" },
    ],
  },

  "chiba-docks": {
    name: "Chiba Docks",
    type: "events",
    description:
      "The Chiba docks burn all night under quartz-halogen floods, cranes swinging like steel giants over the bay. Tokyo Bay lies black and slick with waste, gulls skimming the surface while hover-tugs cough smoke into the rain. Containers shift, heavy with contraband biosofts and chrome.",
    quotes: [
      "The docks... quartz‑halogen floodlights that illuminate the docks all night like vast stages. Tokyo Bay lies as a black expanse with drifting shoals of waste…",
      "The Chiba docks burn all night under quartz-halogen floods, cranes swinging like steel giants over the bay.",
      "Tokyo Bay lies black and slick with waste, gulls skimming the surface while hover-tugs cough smoke into the rain.",
      "Containers shift, heavy with contraband biosofts and chrome.",
    ],
    parent: "night-city",
    people: [],
  },

  "jarre-de-the": {
    name: "Jarre de Thé",
    type: "bar",
    description:
      "Two blocks west of the pastel decay of the Chatsubo, the Jarre de Thé stands compressed between neon glare and fog. Inside, red‑neon frames encase mirrored walls that refract every cigarette glow and twitch of motion. The décor: a pale, retro fusion of Japanese minimalism and Milanese plastics.",
    quotes: [
      "The Jarre was walled with mirrors, each panel framed in red neon.",
      "Two blocks west of the pastel decay of the Chatsubo, the Jarre de Thé stands compressed between neon glare and fog.",
      "Inside, red‑neon frames encase mirrored walls that refract every cigarette glow and twitch of motion.",
      "The décor: a pale, retro fusion of Japanese minimalism and Milanese plastics.",
    ],
    parent: "night-city",
    people: [],
  },

  "cheap-hotel": {
    name: "Cheap Hotel",
    type: "hotel",
    hotel: {
      roomLabel: "Capsule",
      price: 50,
      health: 50,
    },
    description:
      "A featureless ten-story office building in ugly yellow brick with an unlit neon sign near the main entrance...",
    quotes: [
      "Now he slept in the cheapest coffins, the ones nearest the port, beneath the quartz-halogen floods that lit the docks all night like vast stages…",
      "…wake alone in the dark, curled in his capsule in some coffin hotel, his hands clawed into the bedslab, temperfoam bunched between his fingers, trying to reach the console that wasn't there.",
      "A block down Baiitsu, toward the port, stood a featureless ten-story office building in ugly yellow brick. Its windows were dark now, but a faint glow from the roof was visible if you craned your neck.",
      "If the place had another name, Case didn't know it; it was always referred to as Cheap Hotel. You reached it through an alley off Baiitsu, where an elevator waited at the foot of a transparent shaft.",
      "The elevator, like Cheap Hotel, was an afterthought, lashed to the building with bamboo and epoxy. Case climbed into the plastic cage and used his key, an unmarked length of rigid magnetic tape.",
      "Case had rented a coffin here, on a weekly basis, since he'd arrived in Chiba, but he'd never slept in Cheap Hotel. He slept in cheaper places.",
    ],
    parent: "night-city",
    people: [],
  },

  arcade: {
    name: "Arcade",
    type: "arcade",
    description:
      "Electronic thunder fills the air as joystick junkies crowd in to smoke, burn cash, and lose hours to games like Wizard's Castle and Tank War Europa.",
    quotes: [
      "Under bright ghosts burning through a blue haze of cigarette smoke, holograms of Wizard's Castle, Tank War Europa, the New York skyline.",
      "And now he remembered her that way, her face bathed in restless laser light, features reduced to a code",
      "her cheekbones flaring scarlet as Wizard's Castle burned, forehead drenched with azure when Munich fell to the Tank War",
      "mouth touched with hot gold as a gliding cursor struck sparks from the wall of a skyscraper canyon.",
      "the electronic thunder of an arcade.",
    ],
    parent: "night-city",
    people: [],
  },

  "ninsei-strip": {
    name: "Ninsei Strip",
    type: "combat",
    description:
      "Ninsei Strip hums with rain and neon, smoke from stalls mixing with ozone off cheap grids. Signs for clinics stutter promises in kanji, while hustlers and drunks drift through the glow. Gangers watch from shadowed doorways, knives or chrome ready.",
    quotes: [
      "Ninsei Strip hums with rain and neon, smoke from stalls mixing with ozone off cheap grids.",
      "Signs for clinics stutter promises in kanji, while hustlers and drunks drift through the glow.",
      "Gangers watch from shadowed doorways, knives or chrome ready.",
    ],
    parent: "night-city",
    people: [],
    enemyIds: [
      // All Level 1 enemies
      "simstim_junkie",
      "street_punk",
      "noodle_thief",
      "bar_brawler",
      "drunken_sailor",
      "chatsubo_drunk",
      "simstim_burnout",
      "augment_burnout",
      "braun_microdrone",
      "freeside_refugee",
      "freeside_outcast",
      "sprawl_ganger",
      "derm_junkie",
      "joystick_junkie",
      "arcade_addict",
      "street_surgeon",
      "tech_dropout",
      "zaibatsu_dropout",
      "octagon_junkie",
    ],
  },

  shins: {
    name: "Shin's",
    type: "market",
    description:
      "Tucked behind a raw sushi stall on Shiga Street, Shin deals in cheap steel, street-level weapons, sold quick and quiet for the right price.",
    quotes: [],
    parent: "night-city",
    people: [],
    linksTo: "market",
    itemIds: [
      // Shin's weapons
      "shin_razor",
      "shin_shuriken",
      "shin_pipe",
      "shin_syringe",
      "shin_glass",
      "shin_shank",
      // Level 1 armor
      "street_hoodie",
      "leather_jacket",
      "padded_vest",
      // Health items
      "noodles",
      "beer",
      "dirty_water",
      "tea",
      "bandage",
      "derm_patch",
      "clean_water",
      "coffee",
      "yakitori_skewer",
      "sushi",
      "fresh_sushi",
      "discarded_sushi",
      "raw_tuna",
      "rice_box",
      "chiba_krill",
    ],
  },

  "corporate-black-clinic": {
    name: "Black Clinic",
    type: "clinic",
    description:
      "More slick and polished and expensive than other clinics. The corporate version offers premium cybernetic enhancements with corporate backing, sterile environments, and top-tier surgeons. The prices reflect the quality, but so does the risk—corporate clinics have their own agendas.",
    quotes: [
      "More slick and polished and expensive than other clinics.",
      "The corporate version offers premium cybernetic enhancements with corporate backing.",
      "Sterile environments, and top-tier surgeons.",
      "The prices reflect the quality, but so does the risk—corporate clinics have their own agendas.",
    ],
    parent: "corporate-arcology",
    people: [],
  },

  "mega-corp-towers": {
    name: "Mega Corp Towers",
    type: "corporate",
    description:
      "MegaCorp Towers rise like obsidian monoliths, sheer glass reflecting neon sprawl below. Floodlit perimeters and drones guard their bases, keeping streets away. Inside, climate-sealed corridors smell of ozone, silence broken by server hum and executive whispers. Lives unfold within—housing, clinics, markets—sealed ecosystems owned outright. At night their logos blaze like corporate gods, dominion in light. From street level, they seem untouchable, as though the very air rejects the city's chaos.",
    quotes: [
      "MegaCorp Towers rise like obsidian monoliths, sheer glass reflecting neon sprawl below.",
      "Floodlit perimeters and drones guard their bases, keeping streets away.",
      "Inside, climate-sealed corridors smell of ozone, silence broken by server hum and executive whispers.",
      "Lives unfold within—housing, clinics, markets—sealed ecosystems owned outright.",
      "At night their logos blaze like corporate gods, dominion in light.",
      "From street level, they seem untouchable, as though the very air rejects the city's chaos.",
    ],
    parent: "corporate-arcology",
    people: [],
  },

  "hosaka-facility": {
    name: "Hosaka Corporate Facility",
    type: "corporate",
    description:
      "Hosaka Headquarters is an engine, a fortress of glass and steel in the corporate grid. Security saturates the place—biometric gates, drones, men in suits with dead smiles. Inside, offices and data vaults pulse with research, deals, and black code. Executives pass like packets, insulated and unknowable. Outside, the logo glows sterile against dark, a beacon of inevitability. Hosaka doesn't just occupy space—it colonizes it, shaping each breath into corporate property.",
    quotes: [
      "Hosaka Headquarters is an engine, a fortress of glass and steel in the corporate grid.",
      "Security saturates the place—biometric gates, drones, men in suits with dead smiles.",
      "Inside, offices and data vaults pulse with research, deals, and black code.",
      "Executives pass like packets, insulated and unknowable.",
      "Outside, the logo glows sterile against dark, a beacon of inevitability.",
      "Hosaka doesn't just occupy space—it colonizes it, shaping each breath into corporate property.",
    ],
    parent: "corporate-arcology",
    people: [],
  },

  "corporate-streets": {
    name: "The Streets",
    type: "combat-zone",
    description:
      "Corporate District streets are clean, well-lit, and heavily patrolled. Security drones hover overhead, and corporate security forces maintain order. The streets here are safer than the sprawl below, but crossing the wrong corporate entity can have serious consequences.",
    quotes: [
      "Corporate District streets are clean, well-lit, and heavily patrolled.",
      "Security drones hover overhead, and corporate security forces maintain order.",
      "The streets here are safer than the sprawl below, but crossing the wrong corporate entity can have serious consequences.",
    ],
    parent: "corporate-arcology",
    people: [],
    enemyProbabilities: {
      3: 40, // Level 3: 40%
      4: 35, // Level 4: 35%
      5: 20, // Level 5: 20%
      6: 5, // Level 6: 5%
    },
    enemyIds: [
      // Level 3+ enemies only for corporate areas
      "clinic_repoman",
      "syndicate_runner",
      "black_clinic_security",
      "biosoft_heavy",
      "razorgirl",
      "pit_fighter",
      "yakuza_enforcer",
      "mercenary",
      "bodyguard",
      "assassin",
    ],
  },

  "corporate-market": {
    name: "Market",
    type: "market",
    description: "This links to the Market",
    quotes: ["This links to the Market"],
    parent: "corporate-arcology",
    people: [],
    linksTo: "market",
  },

  "julius-dean": {
    name: "Julius Dean Import Export",
    type: "market",
    description:
      "A dimly lit warehouse converted into a trading post. Julius Dean's operation deals in everything from legitimate electronics to questionable biosofts. The air smells of ozone and desperation, with crates stacked to the ceiling and deals made in hushed tones.",
    quotes: [
      "A dimly lit warehouse converted into a trading post.",
      "Julius Dean's operation deals in everything from legitimate electronics to questionable biosofts.",
      "The air smells of ozone and desperation, with crates stacked to the ceiling and deals made in hushed tones.",
    ],
    parent: "night-city",
    people: [],
  },

  "beautiful-girl": {
    name: "Beautiful Girl",
    type: "food",
    description:
      "A small noodle stand that's been here for decades. The name is ironic—the place is anything but beautiful, with cracked plastic tables and fluorescent lighting that makes everyone look sickly. But the ramen is legendary among the locals, and the prices keep the corporate types away.",
    quotes: [
      "A small noodle stand that's been here for decades.",
      "The name is ironic—the place is anything but beautiful, with cracked plastic tables and fluorescent lighting that makes everyone look sickly.",
      "But the ramen is legendary among the locals, and the prices keep the corporate types away.",
    ],
    parent: "night-city",
    people: [],
  },

  namban: {
    name: "Namban",
    type: "bar",
    description:
      "A dive bar that serves as neutral ground in the Ninsei Strip. The walls are covered in old corporate propaganda and faded photos of better days. The drinks are cheap, the music is loud, and everyone minds their own business. A good place to disappear for a while.",
    quotes: [
      "A dive bar that serves as neutral ground in the Ninsei Strip.",
      "The walls are covered in old corporate propaganda and faded photos of better days.",
      "The drinks are cheap, the music is loud, and everyone minds their own business.",
      "A good place to disappear for a while.",
    ],
    parent: "night-city",
    people: [],
  },
};

// Helper functions
export const getLocation = (locationId) => {
  return locations[locationId] || null;
};

export const getLocationEnemies = (locationId) => {
  const location = locations[locationId];
  if (!location || !location.enemyProbabilities || !location.enemyIds) {
    return null;
  }

  return {
    probabilities: location.enemyProbabilities,
    enemyIds: location.enemyIds,
  };
};

export const getLocationType = (locationId) => {
  const location = locations[locationId];
  return location ? location.type : null;
};

export const getRandomQuote = (locationId) => {
  const location = locations[locationId];
  if (!location || !location.quotes || !Array.isArray(location.quotes)) {
    return null;
  }

  const randomIndex = Math.floor(Math.random() * location.quotes.length);
  return location.quotes[randomIndex];
};

export default locations;
